import ExerciseCard, { ExerciseCardProps } from "../../components/exercise-card";
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import ChatHeader from "../../components/chat-header";
import { useLayoutContext } from "../../layouts/general-layout";
import { book, warningIcon } from "../../assets/images/index";
import { RouterConstant } from "../../routers/index";
import Dropdown from "../../components/dropdown/index";
import Button from "../../components/button";
import { SearchExerciseService } from "../../services/search-exercise/search-exercise.service";
import { arrowDown } from "../../assets/images/index";


import "./search-by-book.scss";

export default function Index() {
  const { t } = useLayoutContext();
  const navigate = useNavigate();
  const { ROUTERS_PATH } = RouterConstant;
  const searchExerciseService = new SearchExerciseService();
  const [bookOptions, setBookOptions] = useState([{ value: '', label: t('all') }]);
  const [bookName, setBookName] = useState('');
  const [pageNumber, setPageNumber] = useState('');
  const [exerciseNumber, setExerciseNumber] = useState('');
  const [pageError, setPageError] = useState('');
  const [exerciseError, setExerciseError] = useState('');
  const [loading, setLoading] = useState(false);
  const [noExerciseError, setNoExerciseError] = useState('');
  const isFormValid = bookName && pageNumber && exerciseNumber && !pageError && !exerciseError;

  useEffect(() => {
    fetchExerciseBooks();
  }, []);

  const fetchExerciseBooks = async () => {
    try {
      const books = await searchExerciseService.getExerciseBooks();
      const formatted = books.map((l: any) => ({ value: l.id.toString(), label: l.name }));
      setBookOptions([{ value: '', label: t('all') }, ...formatted]);
    } catch (error) {
      console.error("Failed to fetch exercise books:", error);
    }
  };

  const handleSearch = async () => {
    if (!isFormValid) return;
  
    setLoading(true);
    setNoExerciseError('');
    try {
      const response = await searchExerciseService.searchExerciseByBook({
        book_id: Number(bookName),
        page_number: Number(pageNumber),
        exercise_number: Number(exerciseNumber),
      });
      if (response && response?.id) {
        navigate(ROUTERS_PATH.DISPLAYEXERCISE, {
          state: { exerciseData: response, from: "searchByBook" },
        });
      } else {
        setNoExerciseError(t("exerciseNumberNotFound"));
      }
    } catch (error) {
      console.error("Search failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const cardItems: ExerciseCardProps =
  {
    title: t("card3Title"),
    description: t("card3Des"),
    imgSrc: book,
    color: "purple",
  }
  return (
    <div className="search-by-book-page">
      <ChatHeader
        chatHeading={t("card3ButtonText")}
        onBackClick={() => navigate(ROUTERS_PATH.CHOOSEEXERCISE)}
      />
      <div className="search-by-book-wrapper">
        <div>
          <div className="exercise-cards">
            <ExerciseCard key={0} {...cardItems} />
            </div>
            <div className="search-by-book-detail">
              <div className="search-by-book-field">
                <div className="position-relative">
                  <Dropdown
                    label={t('bookName')}
                    value={bookName}
                    options={bookOptions}
                    onChange={(val) => setBookName(val.toString())}
                  />

                <img src={arrowDown} alt="arrow" className="acc_arrow"/>
                </div>
                <div className={`form-field ${pageError ? 'error' : ''}`}>
                  <input
                    type="number"
                    min="1"
                    max="300"
                    placeholder={t("pageNumber")}
                    value={pageNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (Number(value) > 300) {
                        setPageError(t('pageNumber300'));
                      } else {
                        setPageError('');
                        setPageNumber(value);
                      }
                    }}
                  />
                    {pageError && <span className="error-text"><img src={warningIcon} alt="" />{pageError}</span>}
                </div>
                <div className={`form-field ${exerciseError ? 'error' : ''}`}>
                  <input
                    type="number"
                    min="1"
                    max="500"
                    placeholder={t("exerciseNumber")}
                    value={exerciseNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (Number(value) > 300) {
                        setExerciseError(t('exerciseNumber500'));
                      } else {
                        setExerciseError('');
                        setExerciseNumber(value);
                      }
                    }}
                  />
                    {exerciseError && <div className="error-text"><img src={warningIcon} alt="" /><span>{exerciseError}</span></div>}
                    {noExerciseError && <div className="error-text"><img src={warningIcon} alt="" /><span>{noExerciseError}</span></div>}
                </div>
              </div>
            </div>
        </div>
              <Button type="submit" text={t("choose")} color="blue"  disabled={!isFormValid || loading } loader={loading} onClick={handleSearch}/>
      </div>
    </div>
  );
}